export default (function (w, d) {
        'use strict';

        function Search() {
            this.initSearch();
        }

        Search.prototype.initSearch = function () {
            $(function () {
                    const searchResults = $('.search_results');
                    $(document).on('click', function (e) {
                        if ($(searchResults).hasClass('make_visible')) {
                            $(searchResults).removeClass('make_visible').hide();
                        }
                    });
                    $('.search_reset').on('click', function () {
                        $('input.search').val('')
                        $(this).hide()
                    });
                    $('.brands_search_reset').on('click', function () {
                        $('input.brands_search').val('')
                        $(this).hide()
                    });
                    $('input.search').on('input', function (e) {
                        if (e.target.value.length > 0) {
                            $('.search_reset').show();
                        }
                        $(searchResults).html('');
                        setTimeout(function () {
                            let search = e.target.value;
                            $.ajax({
                                method: 'post',
                                url: '/search',
                                data: {query: search},
                                success: function (data) {
                                    $(searchResults).html('');
                                    if (data.html && data.html.length > 0) {
                                        $(searchResults).append(data.html);
                                        $(searchResults).addClass('make_visible').show();
                                    }
                                }
                            });
                        }, 750);
                    })

                    $('input.brands_search').on('input change', function (e) {
                        if (e.target.value.length > 0) {
                            $('.brands_search_reset').show();
                        }
                        setTimeout(function () {
                            let query = e.target.value;
                            let brands = $('.brands-slider .items .item');

                            $(brands).each(function (index, brand) {
                                let result = brand.text.toLowerCase().search(new RegExp(query, "i"))
                                if (result < 0) {
                                    $(brand).fadeOut();
                                } else {
                                    $(brand).show();
                                }
                            })
                        }, 500)
                    });
                }
            );
        }

        return Search;
    }
    (window, document)
)
;

